import StockLocationChange from './../../views/stockLocationChanges/StockLocationChange'
const stockLocationChanges = [
  {path: '/stock-location-change', name: 'stock-location-change', component: StockLocationChange},

]
export default stockLocationChanges

